<template class="p-1">
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-row>
        <b-col>
          <b-card>
            <div slot="header">
              <strong>mProve</strong> <small>Diagnostics</small>
              <div class="ml-3" style="display: inline-flex;">
                From: &nbsp;<date-picker v-model="request.dateStart" :config="dpConfig" style="width: 100px;height: 25px;"></date-picker>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                To: &nbsp;<date-picker v-model="request.dateEnd" :config="dpConfig" style="width: 100px;height: 25px;"></date-picker>
                <a href="#" @click="getData"><i class="ml-3 fa fa-youtube-play" style="font-size: x-large;color: #1f70b5;"></i></a>
              </div>
              <div class="ml-2 pl-5" style="display: inline-flex;text-align:center;" v-show="GetIsNotActiveFeature()">
                <strong>SAMPLE DATA</strong>
              </div>
              <div class="pull-right" style="margin-left:50px;display: inline-flex;">
                Deal Count: {{totalRecords}}&nbsp;&nbsp;
                |&nbsp;&nbsp;Opportunity Count: {{totalOppCount}}&nbsp;&nbsp;
                <span v-if="totalOppCount > 0">
                  |&nbsp;&nbsp;Deal Opportunity Avg: ${{(totalOpp / totalRecords).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}&nbsp;&nbsp;
                  |&nbsp;&nbsp;Opportunity Avg: ${{totalOppAvg.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}&nbsp;&nbsp;
                  |&nbsp;&nbsp;<strong>Total Opportunity: ${{ totalOpp.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</strong>
                </span>
              </div>
            </div>

            <dx-data-grid v-if="HasRecords" id="grid-container"
                          height="76vh" :paginate="false"
                          :show-borders="true" :wordWrapEnabled="true"
                          @cell-prepared="cellPrepared" @row-prepared="onRowPrepared"
                          :show-column-lines="true" :columnFixing="{enabled: true}"
                          :row-alternation-enabled="true"
                          :data-source="records">
              <!--<dx-scrolling column-rendering-mode="standard" :useNative="true" />-->
              <dx-scrolling mode="virtual" :useNative="true" />
              <dx-header-filter :visible="true" />

              <dx-column :width="100"
                         data-field="deal_date"
                         data-type="date"
                         alignment="center"
                         :fixed="true"
                         caption="Deal Date" />

              <dx-column :width="80"
                         data-field="deal_number"
                         caption="Deal No"
                         :fixed="true"
                         :header-filter="{allowSearch: true}" />

              <dx-column :width="80"
                         data-field="Year"
                         caption="Year"
                         :header-filter="{allowSearch: true}"
                         [position]="left" />

              <dx-column :width="110"
                         data-field="Make"
                         caption="Make"
                         :header-filter="{allowSearch: true}" />

              <dx-column :width="165"
                         data-field="Model"
                         caption="Model"
                         :header-filter="{allowSearch: true}" />

              <dx-column :width="225"
                         data-field="Trim"
                         caption="Trim"
                         :header-filter="{allowSearch: true}" />
              <!--:allowFiltering="false"-->
              <dx-column :width="95"
                         data-field="contract_type_name"
                         caption="Type"
                         alignment="center" />

              <dx-column :width="100"
                         data-field="term_used"
                         :allowFiltering="false"
                         caption="Contracted Term"
                         :header-filter="{allowSearch: true}"
                         alignment="center" />
              <dx-column :width="100"
                         data-field="term_avail"
                         :allowFiltering="false"
                         caption="Available Term"
                         :header-filter="{allowSearch: true}"
                         alignment="center" />
              <dx-column :width="100"
                         data-field="Payment"
                         data-type="number"
                         :format="{type: 'currency', precision: 2}"
                         :allowFiltering="false"
                         caption="Contracted Payment"
                         alignment="center" />
              <dx-column :width="84"
                         data-field="best_payment_amount"
                         data-type="number"
                         :format="{type: 'currency', precision: 2}"
                         :allowFiltering="false"
                         caption="Available Payment"
                         alignment="center" />

              <dx-column :width="125"
                         data-field="lender_used"
                         caption="Contracted Lender"
                         alignment="center" />

              <dx-column :width="120"
                         data-field="best_lender_code"
                         caption="Available Lender"
                         alignment="center" />

              <dx-column :width="90"
                         data-field="buyrate_used"
                         data-type="number"
                         caption="Contracted Buy Rate"
                         :allowFiltering="false"
                         alignment="center" />
              <dx-column :width="90"
                         data-field="sellrate_used"
                         data-type="number"
                         caption="Contracted Money Factor"
                         :allowFiltering="false"
                         alignment="center" />
              <dx-column :width="90"
                         data-field="buyrate_avail"
                         data-type="number"
                         caption="Available Buy Rate"
                         :allowFiltering="false"
                         alignment="center" />

              <dx-column :width="90"
                         data-field="reserve_used"
                         :format="{type: 'currency', precision: 2}"
                         caption="Contracted Reserve"
                         :allowFiltering="false"
                         alignment="right" />

              <dx-column :width="90"
                         data-field="reserve_avail"
                         :format="{type: 'currency', precision: 2}"
                         caption="Available Reserve"
                         :allowFiltering="false"
                         alignment="right" />

              <dx-column :width="90"
                         data-field="rv_used"
                         caption="Contracted RV"
                         :allowFiltering="false"
                         alignment="center" />

              <dx-column :width="90"
                         data-field="rv_avail"
                         caption="Available RV"
                         :allowFiltering="false"
                         alignment="center" />

              <dx-column :width="90"
                         data-field="rebates_used"
                         :format="{type: 'currency', precision: 2}"
                         caption="Contracted Rebate"
                         :allowFiltering="false"
                         alignment="right" />

              <dx-column :width="90"
                         data-field="rebates_avail"
                         :format="{type: 'currency', precision: 2}"
                         caption="Available Rebate"
                         :allowFiltering="false"
                         alignment="right" />

              <dx-column :width="100"
                         data-field="incentive_used"
                         :format="{type: 'currency', precision: 2}"
                         caption="Contracted Incentive"
                         :allowFiltering="false"
                         alignment="right" />

              <dx-column :width="100"
                         data-field="incentive_avail"
                         :format="{type: 'currency', precision: 2}"
                         caption="Available Incentive"
                         :allowFiltering="false"
                         alignment="right" />

              <!--<dx-column :width="100"
             data-field="realized_vehicle_profit"
             :format="{type: 'currency', precision: 2}"
             caption="Contracted Vehicle Profit"
             :allowFiltering="false"
             alignment="right" />

  <dx-column :width="100"
             data-field="avail_vehicle_profit"
             :format="{type: 'currency', precision: 2}"
             caption="Available Vehicle Profit"
             :allowFiltering="false"
             alignment="right" />-->

              <dx-column :width="100"
                         data-field="realized_fi_profit"
                         :format="{type: 'currency', precision: 2}"
                         caption="Contracted F&I Profit"
                         :allowFiltering="false"
                         alignment="right" />

              <dx-column :width="90"
                         data-field="avail_fi_profit"
                         :format="{type: 'currency', precision: 2}"
                         caption="Available F&I Profit"
                         :allowFiltering="false"
                         alignment="right" />

              <dx-column :width="100"
                         data-field="total_realized_profit"
                         :format="{type: 'currency', precision: 2}"
                         caption="Total Contracted Profit"
                         :allowFiltering="false"
                         alignment="right" />

              <dx-column :width="100"
                         data-field="total_avail_profit"
                         :format="{type: 'currency', precision: 2}"
                         caption="Total Available Profit"
                         :allowFiltering="false"
                         alignment="right" />

              <dx-column :width="100"
                         data-field="opportunity"
                         :format="{type: 'currency', precision: 2}"
                         caption="Opportunity"
                         :allowFiltering="false"
                         alignment="right" />

              <dx-column :width="250"
                         data-field="opportunity_components"
                         caption="Opportunity Components"
                         :allowFiltering="false"
                         alignment="center" />

            </dx-data-grid>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import { setTimeout } from 'timers'

import datePicker from 'vue-bootstrap-datetimepicker'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'

import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
// import 'devextreme/dist/css/dx.material.blue.light.css';

import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxSearchPanel,
  DxFilterRow,
  DxMasterDetail,
  DxPager,
  DxPaging,
  DxScrolling
} from 'devextreme-vue/data-grid'

export default {
  name: 'mprovereport',
  components: {
    loading,
    datePicker,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxFilterRow,
    DxMasterDetail,
    DxPager,
    DxPaging,
    DxScrolling
  },
  created () {
    this.initDates()
    this.getData()
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: true,
      txtLoading: 'Loading...',
      records: [],
      request: { dateStart: '2019/01/01', dateEnd: '2019/12/31' },
      totalRecords: 0,
      totalOpp: 0,
      totalOppCount: 0,
      totalOppAvg: 0,
      IsActiveFeature: true,
      dpConfig: {
        format: 'MM/DD/YYYY',
        useCurrent: false
      }
    }
  },
  computed: {
    HasRecords () {
      var self = this
      if (self.records === undefined || self.records.length === 0) {
        return false
      }
      return true
    }
  },
  methods: {
    initDates () {
      var Year = new Date().getFullYear()
      this.request.dateStart = new Date(Year, 0, 1, 0, 0, 0)
      this.request.dateEnd = new Date(Year, 11, 31, 0, 0, 0)
    },
    getData () {
      var self = this
      self.boolLoading = true
      axios.post('/api/mprove/getdata', self.request)
        .then(response => {
          self.showDismissibleAlert = false
          if (response.data.records === undefined || response.data.records == null) {
            self.errMsg = 'No data was returned'
            self.showDismissibleAlert = true
          } else {
            self.records.splice(0)
            let idx = response.data.records.length
            for (let i = 0; i < idx; i++) {
              self.records.push(response.data.records[i])
            }
            self.IsActiveFeature = response.data.mProve.IsActive

            self.totalRecords = this.records.length
            self.records.forEach(i => {
              self.totalOpp += i.opportunity
              self.totalOppCount += i.opportunity > 0 ? 1 : 0
            })
            self.totalOppAvg = self.totalOpp / self.totalOppCount
          }
          self.boolLoading = false
        })
        .catch(error => {
          if (error.response.status == 403) { self.$router.push('/login') }

          self.boolLoading = false
          self.errMsg = 'There was an error getting data : ' + error
          self.showDismissibleAlert = true
        })
    },
    GetIsNotActiveFeature () {
      return this.IsActiveFeature === false
    },
    onRowPrepared (e) {

      // e.rowElement.style.height = 30;
    },
    cellPrepared (e) {
      if (e.rowType === 'data') {
        if (e.data.contract_type === 'L') {
          if (e.column.dataField === 'buyrate_avail') {
            if (e.data.buyrate_avail < e.data.sellrate_used) { e.cellElement.classList.add('greenCell') }
            if (e.data.buyrate_avail > e.data.sellrate_used) { e.cellElement.classList.add('redCell') }
          }
        }
        if (e.data.contract_type === 'P') {
          if (e.column.dataField === 'sellrate_avail') {
            if (e.data.sellrate_avail < e.data.buyrate_used) { e.cellElement.classList.add('greenCell') }
            if (e.data.sellrate_avail > e.data.buyrate_used) { e.cellElement.classList.add('redCell') }
          }
        }
        if (e.column.dataField === 'reserve_avail') {
          if (e.data.reserve_avail > e.data.reserve_used) { e.cellElement.classList.add('greenCell') }
          if (e.data.reserve_avail < e.data.reserve_used) { e.cellElement.classList.add('redCell') }
        }
        if (e.column.dataField === 'rebates_avail') {
          if (e.data.rebates_avail > e.data.rebates_used) { e.cellElement.classList.add('greenCell') }
          if (e.data.rebates_avail < e.data.rebates_used) { e.cellElement.classList.add('redCell') }
        }
        if (e.column.dataField === 'incentive_avail') {
          if (e.data.incentive_avail > e.data.incentive_used) { e.cellElement.classList.add('greenCell') }
          if (e.data.incentive_avail < e.data.incentive_used) { e.cellElement.classList.add('redCell') }
        }
        if (e.column.dataField === 'lender_avail') {
          if (e.data.lender_avail != e.data.lender_used && e.data.opportunity > 0) { e.cellElement.classList.add('greenCell') }
        }
        if (e.column.dataField === 'term_avail') {
          if (e.data.term_avail < e.data.term_used) { e.cellElement.classList.add('greenCell') }
        }
        if (e.column.dataField === 'rv_avail') {
          if (e.data.rv_avail > e.data.rv_used) { e.cellElement.classList.add('greenCell') }
          if (e.data.rv_avail < e.data.rv_used) { e.cellElement.classList.add('redCell') }
        }
        if (e.column.dataField === 'avail_vehicle_profit') {
          if (e.data.avail_vehicle_profit > e.data.realized_vehicle_profit) { e.cellElement.classList.add('greenCell') }
          if (e.data.avail_vehicle_profit < e.data.realized_vehicle_profit) { e.cellElement.classList.add('redCell') }
        }
        if (e.column.dataField === 'total_avail_profit') {
          if (e.data.total_avail_profit > e.data.total_realized_profit) { e.cellElement.classList.add('greenCell') }
          if (e.data.total_avail_profit < e.data.total_realized_profit) { e.cellElement.classList.add('redCell') }
        }
        if (e.column.dataField === 'reserve_avail') {
          if (e.data.reserve_avail > e.data.reserve_used) { e.cellElement.classList.add('greenCell') }
          if (e.data.reserve_avail < e.data.reserve_used) { e.cellElement.classList.add('redCell') }
        }

        if (e.column.dataField === 'opportunity' || e.column.dataField === 'deal_number') {
          if (e.data.opportunity > 0) { e.cellElement.classList.add('greenCell') }
        }
      }
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = false
  }
}
</script>

<style>

  body {
    background-color: #e4e5e6;
  }

  .breadcrumb {
    display: none !important;
  }

  .main .container-fluid {
    padding: 0.25rem !important;
  }

  .dx-datagrid .dx-row > td {
    font-size: 11px;
  }

  .greenCell {
    background-color: #a0ffad !important;
    color: #000000;
  }

  .redCell {
    background-color: #f88379 !important;
    color: #000000;
  }

  #grid-container tr.main-row td:not(:first-child) {
    height: 21px;
    background-color: #f88379 !important;
  }

  .dx-datagrid-headers .dx-datagrid-table .dx-row > td {
    text-align: center !important
  }
</style>



// WEBPACK FOOTER //
// src/views/mProveReport.vue